<i18n>
{
  "en": {
    "averageticket": "Average ticket"
  },
  "es": {
    "averageticket": "Ticket medio"
  }
}
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import * as KPITypes from '../constants';
import KpiComponent from './KpiComponent.vue';

@Component
@MapActions(['calculateAverageTicketKPI'])
export default class RevenueKpi extends KpiComponent {
  icon = 'mdi-receipt'

  iconSize = 21;

  kpiType = KPITypes.AVERAGE_TICKET

  isCurrencyUnit = true

  get title() {
    return this.$t('averageticket');
  }

  async calculate() {
    await this.calculateAverageTicketKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
